// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2k_Ui","list":"PatternAutocomplete_list__1d2yH"};